// ext-src/dialogs/StartEnrichmentDialog.tsx
import { Sheet, SheetContent } from "../components/ui/sheet"
import * as Dialog from "@radix-ui/react-dialog"
import EnrichmentConfigView from "../views/EnrichmentConfigView/EnrichmentConfigView"
import { ScrollArea } from "../components/ui/scroll-area"
import { X } from "lucide-react";
import { Button } from "../components/ui/button";
import { useTranslation } from "../i18n/hooks";

type StartEnrichmentDialogProps = {
  open: boolean;
  onOpenChange: (arg: boolean) => void;
}

export function StartEnrichmentDialog({ open, onOpenChange }: StartEnrichmentDialogProps) {
  const { t } = useTranslation();
  
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent 
        side="right" 
        className="w-full lg:max-w-5xl z-[100] p-0"
        >
        {/* Scrollable area that takes remaining height */}
        <div className="h-full flex flex-col overflow-hidden"> {/* Added wrapper */}
          <EnrichmentConfigView />
        </div>
      </SheetContent>
    </Sheet>
  )
}